














































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  IPrivateAccount,
  getAccountStatus,
  getAccountList,
  getAccountArea,
  addEditAccount,
  deleteAccount,
  setAccountUsed
} from '@/api/developer/developer-private/private'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString,
  deepCopy
} from '@/utils/tool'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

type actStatus = 'open' | 'close'

const statisticList = [
  {
    name: '今日新增用户',
    count: 1256
  },
  {
    name: '本周新增用户',
    count: 256
  },
  {
    name: '本月新增用户',
    count: 2561
  },
  {
    name: '测试用户',
    count: 256
  },
  {
    name: '累计开发者',
    count: 25
  }
]

@Component({
  name: 'UserInfo'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    id: '',
    account: '',
    status: '',
    createDateStart: '',
    createDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private addParams = {
    username: '',
    password: ''
  }
  // component data
  statisticList = statisticList
  tableLoading = false
  private tableData: any[] = []
  private statusList: any[] = []
  private areaList: any[] = []
  private selectedData: any[] = []
  private dateArray: string[] = ['', '']
  private totalCount = 0
  private addFormVisible: boolean = false
  private rules: any = {
    username: [{ required: true, message: '请填写账号', trigger: 'blur' }],
    password: [{ required: true, message: '请填写密码', trigger: 'blur' }]
  }
  tableHeight: number = 800
  // lifecycle
  async created() {
    this.getTableData()
    // this.getAccountStatus()
    // this.getAreaList()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 75 - filterDom.getBoundingClientRect().bottom
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    // let res = await getAccountList(this.params)
    for (let i = 0; i < 10; i++) {
      this.tableData.push({
        id: i + 1,
        username: 'jrj4aj9@163.com',
        usertype: 'Jinx',
        currentStatus: '在线',
        registerDate: '2019-11-11 11:11:11',
        location: '北京市'
      })
    }
    this.tableLoading = false
    // this.tableData = res.data.dataList
    // this.totalCount = res.data.pageInfo.totalCount
  }
  async getAccountStatus() {
    let res: any = await getAccountStatus()
    this.statusList = res.data.dataList
  }
  async handleExcel() {
    // let excelParams = deepCopy(this.params)
    // let res: any = await getAccountList(
    //   Object.assign(excelParams, {
    //     page: 1,
    //     pageCount: 3000
    //   })
    // )
    // if (res.status.code === 0) {
    //   setTimeout(() => {
    //     this['$message'].success('导出成功!')
    //   }, 200)
    // } else {
    //   this['$message'].error('导出失败!')
    //   return
    // }
    const filterVal: string[] = [
      'id',
      'accountId',
      'certName',
      'applePwd',
      'iphoneCount',
      'itouchCount',
      'status',
      'info',
      'createDate',
      'creatorName'
    ]
    const theader: string[] = [
      'ID',
      '开发者账号',
      '证书',
      '专用密码',
      'iPhone可安装数量',
      'iPad可安装数量',
      '状态',
      '信息',
      '创建时间',
      '创建人'
    ]
    if (this.selectedData.length <= 0) {
      return this.$message.warning('请选择数据')
    }
    const list = this.tableData
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
    this['$message'].success('导出成功!')
    ;(this.$refs['multiTable'] as any).clearSelection()
  }
  async getAreaList() {
    let res: any = await getAccountArea()
    this.areaList = res.data.dataList
  }
  async addEditAccount() {
    // let res: any = await addEditAccount(this.addParams)
    // if (res.status.code === 0) {
    //   this['$message'].success('提交成功!')
    //   this.cancelAddForm()
    // } else {
    //   this['$message'].error('提交失败!')
    // }
  }
  async deleteAccount(ids: string) {
    // let res: any = await deleteAccount({
    //   id: ids
    // })
    // if (res.status.code === 0) {
    //   this['$message'].success('删除成功')
    // } else {
    //   this['$message'].error('删除失败')
    // }
  }
  // 批量开启 && 关闭
  async setAccount(type: actStatus, ids: string) {
    // let isUsed = type === 'open'
    // let res: any = await setAccountUsed({
    //   id: ids,
    //   use: isUsed ? 1 : -1
    // })
    // if (res.status.code === 0) {
    //   let t = ids.split(',')
    //   this.tableData.forEach(item => {
    //     if (t.includes(item.id.toString())) {
    //       item.isUse = isUsed
    //     }
    //   })
    //   isUsed ? this['$message'].success('账号启用成功!') : this['$message'].info('账号关闭成功!')
    // }
  }
  handleDateChange(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArray = ['', '']
    this.params.page = 1
  }
  handleAdd() {
    this.addFormVisible = true
  }
  handleSelectionChange(list: any[]) {
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleOpenAll(type: actStatus) {
    let canClose = this.selectedData.some(item => item.isUse)
    if (canClose) {
      this['$message'].warning('请选择正确状态的账号进行启用!')
      return
    }
    this.setAccount(type, this.selectIds)
  }
  handleCloseAll(type: actStatus) {
    let canClose = this.selectedData.some(item => !item.isUse)
    if (canClose) {
      this['$message'].warning('请选择正确状态的账号进行关闭!')
      return
    }
    this.setAccount(type, this.selectIds)
  }
  handleRemoveAll() {
    let canDelete = this.selectedData.some(item => item.isUse)
    if (canDelete) {
      this['$message'].warning('请选择正确状态的账号进行删除!')
      return
    }
    this.deleteAccount(this.selectIds)
  }
  async setUsed(item: IPrivateAccount) {
    const { id } = item
    let res: any = await setAccountUsed({
      id: id.toString(),
      use: 1
    })
    if (res.status.code === 0) {
      this.$nextTick(() => {
        item.isUse = true
      })
      this['$message'].success('账号启用成功!')
    } else {
      this['$message'].error('账号启用失败!')
    }
  }
  async setunUsed(item: IPrivateAccount) {
    const { id } = item
    let res: any = await setAccountUsed({
      id: id.toString(),
      use: -1
    })
    if (res.status.code === 0) {
      this.$nextTick(() => {
        item.isUse = false
      })
      this['$message'].info('账号关闭成功!')
    } else {
      this['$message'].error('账号关闭失败!')
    }
  }
  setEdit(item: any) {
    // 跳转
    if (!item.id) return
    this['$router'].push({
      name: 'UserDetail',
      query: {
        id: item.id
      }
    })
  }
  setUpdate(item: any) {}
  setRemove(item: any) {}
  todo() {}
  // close dialog, clear data
  handleFormClose() {
    this.cancelAddForm()
  }
  cancelAddForm() {
    (this.$refs['addParams'] as Form).resetFields()
    this.addFormVisible = false
  }
  confirmAddForm() {
    (this.$refs['addParams'] as Form).validate(valid => {
      if (valid) {
        this.addEditAccount()
      } else {
        this['$message'].warning('请填写完成后再提交!')
        return false
      }
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
